import "./member.css";
import { auth, authSubject } from "../../store/auth.store";
import { SubmitHandler, useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import { ApiService } from "lib/http.service";
import { env, professions, regions } from "../../constants/global.vars";
import { toast } from "react-toastify";
import { wssProvider } from "../../services/websocket.service";
import refreshIcon from "../../assets/icons/refresh.svg";
import successIcon from "../../assets/icons/success.svg";
import closedIcon from "../../assets/icons/closed.svg";
import React, { useEffect, useState } from "react";
import { isMobile } from "../../App";
import { copyMemberNumber, dateFormat, useForceUpdate } from "../../services/misc.functions";
import iconCopy from "../../assets/feather/copy.svg";
import { AuthService } from "../../services/auth.service";
import InputAuto from "../register/input.auto";
let s: any;
let resendButton: any;

export function MemberInfo() {
  const [showValidateCodeInput, setShowValidateCodeInput] = useState<any>(false);
  const forceUpdate = useForceUpdate();
  useEffect(() => {
    let auth_subscriber = authSubject.subscribe((res: any) => {
      forceUpdate();
    });
    if (auth.member.profession) {
      setValue("profession", auth.member.profession);
    }
    return () => {
      auth_subscriber.unsubscribe();
    };
  }, []);

  const removeClasses = (ref: any) => {
    ref.classList.remove("border-success");
    ref.classList.remove("bg-success-subtle");
    ref.classList.remove("border-danger");
    ref.classList.remove("bg-danger-subtle");
    ref.classList.remove("border-warning");
    ref.classList.remove("bg-warning-subtle");
  };

  const mobileChangeHandler = (e: any) => {
    if (e.target.value !== auth.member.mobile) {
      removeClasses(e.target);
      e.target.classList.add("border-warning");
      e.target.classList.add("bg-warning-subtle");
    } else if (auth.member.mobile_validation === true) {
      removeClasses(e.target);
      e.target.classList.add("border-success");
      e.target.classList.add("bg-success-subtle");
    } else if (auth.member.mobile_validation !== true) {
      removeClasses(e.target);
      e.target.classList.add("border-danger");
      e.target.classList.add("bg-danger-subtle");
    }
  };

  const senderTimer = (s: any = null) => {
    let resendTimer: any = document.getElementById("id_resendTimer");
    if (resendTimer) {
      let secondLeft: number = Number(
        Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1
      );
      if (secondLeft < 0) {
        clearInterval(s);
        resendButton = document.getElementById("id_resendCode");
        if (resendButton) {
          resendButton.classList.remove("hide");
        }
      } else {
        resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
      }
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors
  } = useForm();

  const onSubmit: SubmitHandler<any> = (payload: any) => {
    const api = new ApiService();
    payload["mobile"] = payload.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");

    api
      .start("post", env.accounting_api + "/member/api/update-account-info/", payload, true)
      .then((res: any) => {
        if (res && res.status) {
          setShowValidateCodeInput(false);
          wssProvider.checkauth();
          toast.success("Hesap bilgileriniz güncellendi.");
        } else if (res && res.error && res.error === "sms_validate") {
          s = setInterval(senderTimer, 1000);
          setShowValidateCodeInput(true);
        } else if (res && res.error && res.error === "mail_validation") {
          console.info("mail_validate");
        } else {
          toast.error(res.message);
        }
      })
      .catch((e: any) => {
        console.error(e);
      });
  };

  return (
    <>
      <h1>Üyelik Bilgilerim</h1>
      <div className="page-widget">
        <form className="member-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row flex-wrap align-items-center">
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              ÜYE NUMARASI
            </label>
            <input
              className="col-lg-3 col-sm-12"
              type="text"
              placeholder="ÜYE NUMARASI"
              {...register("id")}
              value={auth.member.id}
              disabled
            />
          </div>

          <div className="form-row flex-wrap align-items-center ">
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              İSİM SOYİSİM
            </label>
            <input
              className="col-lg-3 col-sm-12"
              type="text"
              placeholder="AD"
              {...register("first_name")}
              value={`${auth.member.first_name} ${auth.member.last_name}`}
              disabled
            />
          </div>

          <div className="form-row flex-wrap align-items-center">
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              DOĞUM TARİHİ
            </label>
            <input
              className="col-lg-3 col-sm-12"
              type="text"
              placeholder="DOĞUM TARİHİ"
              {...register("birthday")}
              value={dateFormat(auth.member.birthday).replaceAll("/", ".")}
              disabled
            />
          </div>

          <div className="form-row row flex-wrap align-items-center">
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              GSM NO
            </label>

            <div className={`${isMobile ? "w-100" : "w-25"} px-0`}>
              <div
                className={`sideInput  align-items-center m-0 p-0 form-control ${auth.member.mobile_validation === true ? "" : "bg-danger-subtle border-danger"
                  }`}
              >
                <InputMask
                  style={{ border: "none", fontSize: 12 }}
                  defaultValue={auth.member.mobile}
                  mask="+\90 (599) 999 99 99"
                  onChangeCapture={mobileChangeHandler}
                  placeholder={"(___) ___ __ __"}
                  id="id_mobile"
                  {...register<any>("mobile", { required: true })}
                />

                {auth.member.mobile_validation === true ? (
                  <img alt={"onayli"} src={successIcon} width={15} height={15} />
                ) : (
                  <></>
                )}
              </div>
              {errors.mobile && (
                <p className="invalid-feedback text-nowrap position-absolute fs-7">Lütfen telefon numarası giriniz.</p>
              )}
            </div>

            {showValidateCodeInput ? (
              <div className="d-flex flex-row col-lg-4 col-sm-8 px-0 px-lg-1 gap-1 mt-2 mt-lg-0">
                <input
                  className={`col-6 form-control ${errors.sms_verify_code ? "border-danger" : ""}`}
                  placeholder="ONAY KODU"
                  {...register<any>("sms_verify_code", { required: true })}
                  id="id_sms_verify_code"
                />

                <button className="btn btn-warning">ONAYLA</button>

                <button
                  className="btn hide btn-sm position-absolute btn-warning"
                  id="id_resendCode"
                  onClick={() => {
                    clearInterval(s);
                    const authService = new AuthService();
                    authService.sendValidationCode(null);
                    if (resendButton) {
                      resendButton.classList.add("hide");
                    }
                    let resendTimer: any = document.getElementById("id_resendTimer");
                    if (resendTimer) {
                      resendTimer.innerHTML = "3:00";
                    }
                    s = setInterval(senderTimer, 1000);
                  }}
                >
                  <img alt={"yenile"} src={refreshIcon} />
                </button>

                <button
                  className="btn"
                  onClick={() => {
                    setShowValidateCodeInput(false);
                    setValue("mobile", auth.member.mobile);
                    removeClasses(document.getElementById("id_mobile"));
                  }}
                >
                  <img alt={"kapat"} src={closedIcon} width={20} height={20} />
                </button>
              </div>
            ) : (
              <div className="col-4"></div>
            )}
          </div>

          <div className="form-row flex-wrap align-items-center">
            <label
              className={`text-nowrap text-nowrap form-label col-12 col-lg-3   ${isMobile ? "text-start" : "text-end"}`}
            >
              E-POSTA
            </label>

            <div className={`${isMobile ? "w-100" : "w-25"} px-0`}>
              <div className={`sideInput col-12`}>
                <input
                  className={`${auth.member.email_validation ? "" : "bg-danger-subtle border-danger"}`}
                  style={{ fontSize: 12, border: "none" }}
                  type="text"
                  placeholder="E-POSTA"
                  {...register("email", { required: true })}
                  defaultValue={auth.member.email}
                />

                {auth.member.email_validation === true ? (
                  <img alt={"onayli"} src={successIcon} width={16} height={16} />
                ) : (
                  <></>
                )}
              </div>

              {errors.mail && <p className="invalid-feedback">Lütfen e-posta adresi giriniz.</p>}
            </div>

            {!auth.member.email_validation && (
              <div className={"col-3 col-lg-2 mt-2 mt-lg-0 px-0 px-lg-1"}>
                <button
                  type={"button"}
                  onClick={() => {
                    const authService = new AuthService();
                    authService.sendEmailValidationLink();
                  }}
                  className="btn btn-warning w-100"
                >
                  ONAYLA
                </button>
              </div>
            )}
          </div>

          <div className={`flex-wrap align-items-center ${isMobile ? "mb-3" : "form-row"}`}>
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              İL
            </label>
            <div className={"col-lg-3 col-sm-12 p-0"}>
              <select className="form-select w-100" defaultValue={auth.member?.city} {...register("city")}>
                <option value="">İl Seçiniz</option>
                {Array.from(new Set(regions.map((region) => region.state))).map((city) => {
                  return (
                    <option value={city} key={`city-${city}`}>
                      {city}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className={`flex-wrap align-items-center ${isMobile ? "mb-3" : "form-row"}`}>
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              MESLEK
            </label>
            <div className={"col-lg-3 col-sm-12 p-0"}>
              <InputAuto
                showInfo={false}
                pholder="Meslek Seçiniz"
                data={professions}
                register={register}
                name={"profession"}
                setValue={setValue}
                clearErrors={clearErrors}
                errors={errors.profession}
                defaultValue={auth.member?.profession}
              />
            </div>
          </div>
          <div className={`flex-wrap align-items-center ${isMobile ? "mb-3" : "form-row"}`}>
            <label
              className={`text-nowrap text-nowrap form-label col-lg-3 col-sm-12  ${isMobile ? "text-start" : "text-end"
                }`}
            >
              REFERANS LİNKİ
            </label>
            <div className={"col-lg-4 col-sm-12 p-0"}>
              <span
                className="d-flex"
                onClick={() =>
                  copyMemberNumber(
                    `https://4nala.com/uye-ol?referer=${auth.member.id.toString(16).toUpperCase()}`,
                    "Referans Linkiniz kopyalandı!"
                  )
                }
              >

                <span
                  className="fw-bold"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  https://4nala.com/uye-ol?referer={auth.member.id.toString(16).toUpperCase()}
                </span>&nbsp; <img src={iconCopy} width={14} />
              </span>
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-3"}></div>
            <div className={"col-6"}>
              <button className="btn btn-warning w-100" type="submit">
                Kaydet
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
